import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useAuthState } from "../AuthProvider";
import Button from "../Button";
import Card from "../Card";
import CardLayout from "../CardLayout";
import Flex from "../Flex";
import Heading from "../Heading";
import Label from "../Label";
import DropDownList from "../DropDownList";

const ClientSelector = ({ onSelect }) => {
  const { user } = useAuthState();
  const clientRef = React.createRef();

  React.useEffect(() => {
    clientRef.current.focus();
  }, [clientRef]);

  return (
    <CardLayout>
      <Card primary>
        <Formik
          initialValues={{ clientId: "" }}
          onSubmit={({ clientId }) => onSelect(clientId)}
          validateOnChange={false}
          validationSchema={Yup.object().shape({
            clientId: Yup.string().required("Account is required")
          })}
        >
          {({ errors, handleChange, handleSubmit, values }) => (
            <form onSubmit={handleSubmit}>
              <Flex gutter={3}>
                <Flex.Item span={12}>
                  <Heading.Two>Accounts</Heading.Two>
                </Flex.Item>
                <Flex.Item span={12}>
                  <DropDownList
                    errorText={errors.clientId}
                    id="clientId"
                    label={
                      <Label
                        error={Boolean(errors.clientId)}
                        htmlFor="clientId"
                      >
                        Account
                      </Label>
                    }
                    onChange={handleChange}
                    ref={clientRef}
                    required
                    value={values.clientId}
                    width="100%"
                  >
                    <DropDownList.Item value="">
                      Choose an account...
                    </DropDownList.Item>
                    {user.clients.map(client => (
                      <DropDownList.Item key={client.id} value={`${client.id}`}>
                        {client.name}
                      </DropDownList.Item>
                    ))}
                  </DropDownList>
                </Flex.Item>
                <Flex.Item span={12}>
                  <Button primary type="submit" width="100%">
                    Select Account
                  </Button>
                </Flex.Item>
              </Flex>
            </form>
          )}
        </Formik>
      </Card>
    </CardLayout>
  );
};

export default ClientSelector;
